import type { AffinityCampaignInfo } from '@/shared/api/CommonService';
import { defineStore } from 'pinia';
import { reactive, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useQuoteStore } from '@/entities/Quote';
import { useABTestStore } from '@/features/flow/ABTesting';
import { AB_GROUPS, AB_TESTS } from '@/features/flow/ABTesting/model/ab-tests';
import { useCommonService } from '@/shared/api/CommonService';
import { useStateUpdate } from '@/shared/lib/pinia/useStateUpdate';

const storeKey = 'AffinityStore';

interface AffinityState {
  affinity: AffinityCampaignInfo | null;
}

function defaultState(): AffinityState {
  return {
    affinity: null,
  };
}

export const useAffinityStore = defineStore('AffinityStore', () => {
  const state = reactive<AffinityState>(defaultState());
  const $update = useStateUpdate<AffinityState>(state);
  const route = useRoute();
  const abStore = useABTestStore();

  const quoteStore = useQuoteStore();
  const commonService = useCommonService();
  const affinityLoading = ref(false);
  async function checkAffinityCampaignAndGetInfo() {
    if (route.query.affinity && typeof route.query.affinity === 'string') {
      const code = route.query.affinity;
      try {
        affinityLoading.value = true;
        state.affinity = await commonService.getAffinityCampaignInfo({ code });
        quoteStore.state.promoCode = state.affinity.promoCode;
        if (state.affinity.promoCode) {
          abStore.abDistribution[AB_TESTS.CORE_INTEGRATION] = AB_GROUPS.A;
        }
      } catch (error) {
        console.error(error);
      } finally {
        affinityLoading.value = false;
      }
    }
  }

  return {
    state,
    $update,
    checkAffinityCampaignAndGetInfo,
    affinityLoading,
  };
}, { persist: { key: storeKey } });
